<template>
  <div>
    <navbar-component />
    <div class="bg-container">
      <warehouse-searchbar-layout :texts="texts"></warehouse-searchbar-layout>
      <warehouse-content-layout :texts="texts"></warehouse-content-layout>
    </div>
    <delete-component />
    <footer-component />
    <whatsapp-component />
  </div>
</template>

<script>
export default {
  name: "WarehouseView",
  data() {
    return {
      //VARIABLES
      texts: "",
    };
  },
  beforeMount() {
    this.texts = FILE.warehouse[this.selectLanguage];
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.warehouse[this.selectLanguage];
      }
    },
  },
};
</script>

<style scoped>
.bg-container {
  width: 100%;
  background: #f2f2f4 0% 0% no-repeat padding-box;
  opacity: 1;
  padding-top: 75px;
}
</style>